import {UPDATE_FILED, CLEAR} from "./Actions";

const defaultState = {
   users: [],
   usersLoad: false,
   cinemas: [],
   cinemasLoad: false,
   halls: [],
   hallsLoad: false,
   sanes: [],
   sanesLoad: false,
   movies: [],
   moviesLoad: false,
   movieSections: [],
   movieSectionsLoad: false,
   abilities: [],
   abilitiesLoad: false,
   roles: [],
   rolesLoad: false,

};

const coreReducer = (state = defaultState, {type, payload}) => {
   switch (type) {
      case UPDATE_FILED:
         return {
            ...state,
            [payload.prop]: payload.value,
         };
      case CLEAR:
         return {...defaultState};
      default:
         return state;
   }
};

export default coreReducer;
